export default __webpack_public_path__ + "static/media/bubble.f984a666.svg";